<template>
  <div>
    <div class="common-header-wrap">
      <mt-header title="店铺入驻" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <step :options="options" :active="0"></step>
    <div class="label">店铺及联系人信息</div>
	<div class="main-content">
	  <flex-line class="field-line" :show-border="true"><span class="field-name">{{storeJoinin.store_type==1?'店铺名称':'公司名称'}}</span><div class="field-line-right" slot="right"><input class="field-input" v-model="storeJoinin.company_name" /></div></flex-line>
	  <div @click="onRegion('company_address')"><flex-line :is-link="true" :show-border="true"><span class="line-name">所在地</span><span slot="right">{{storeJoinin.company_address}}</span></flex-line></div>
	  <div @click="popMap=true"><flex-line :is-link="true" :show-border="true"><span class="line-name">详细地址</span><span slot="right">{{storeJoinin.company_address_detail}}</span></flex-line></div>
	  <flex-line v-if="storeJoinin.store_type==0" class="field-line" :show-border="true"><span class="field-name">注册资金（万元）</span><div class="field-line-right" slot="right"><input class="field-input" v-model="storeJoinin.company_registered_capital" /></div></flex-line>
	  <flex-line class="field-line" :show-border="true"><span class="field-name">联系人姓名</span><div class="field-line-right" slot="right"><input class="field-input" v-model="storeJoinin.contacts_name" /></div></flex-line>
	  <flex-line class="field-line" :show-border="true"><span class="field-name">联系人电话</span><div class="field-line-right" slot="right"><input class="field-input" v-model="storeJoinin.contacts_phone" /></div></flex-line>
	  <flex-line class="field-line" :show-border="true"><span class="field-name">电子邮箱</span><div class="field-line-right" slot="right"><input class="field-input" v-model="storeJoinin.contacts_email" /></div></flex-line>

	</div>
	<div class="label">{{storeJoinin.store_type==0?'营业执照信息（副本）':'证件信息'}}</div>
	<div class="main-content">
	  <flex-line class="field-line" :show-border="true"><span class="field-name">{{storeJoinin.store_type==0?'营业执照号':'证件号码'}}</span><div class="field-line-right" slot="right"><input class="field-input" v-model="storeJoinin.business_licence_number" /></div></flex-line>
	  <div v-if="storeJoinin.store_type==0" @click="onRegion('business_licence_address')"><flex-line :is-link="true" :show-border="true"><span class="line-name">营业执照所在地</span><span slot="right">{{storeJoinin.business_licence_address}}</span></flex-line></div>
	  <div v-if="storeJoinin.store_type==0" @click="onDate('business_licence_start')"><flex-line :is-link="true" :show-border="true"><span class="line-name">有效期起始</span><span slot="right">{{storeJoinin.business_licence_start}}</span></flex-line></div>
	  <div v-if="storeJoinin.store_type==0" @click="onDate('business_licence_end')"><flex-line :is-link="true" :show-border="true"><span class="line-name">有效期结束</span><span slot="right">{{storeJoinin.business_licence_end}}</span></flex-line></div>
	  <flex-line v-if="storeJoinin.store_type==0" class="field-line" :show-border="true"><span class="field-name">经营范围</span><div class="field-line-right" slot="right"><input class="field-input" v-model="storeJoinin.business_sphere" /></div></flex-line>
	  <flex-line class="pt-5" :show-border="true">
	    <span>{{storeJoinin.store_type==0?'营业执照电子版':'证件照片'}}</span>
	    <div slot="right">
	      <div class="user-avatar-wrapper">
	        <div v-if="storeJoinin.business_licence_number_electronic" class="user-avatar">
	          <img :src="storeJoinin.business_licence_number_electronic_url" @click="openImage(storeJoinin.business_licence_number_electronic_url)">
	          <span @click="dropImage()" class="del-btn iconfont">&#xe6d8;</span>
	        </div>
	        <div v-else class="user-avatar iconfont icon-xiangji" ref="upload_btn1" @change="uploadImage('business_licence_number_electronic',$event)">
	          <div class="center-text">相机/相册</div>
	          <input type="file" accept="image/*">
	        </div>
	      </div>
	    </div>
	  </flex-line>
	</div>
    <div class="common-btn ds-button-large mt-10"  @click="nextStep">下一步</div>

    <div>
      <mt-popup v-model="isshow" popup-transition="popup-fade" class="popup" >
        <img :src="showimage" :style="getBannerStyle" @click="isshow=false">
      </mt-popup>
    </div>
    <div>
      <region-picker ref="picker" @onConfirm="onPickerConfirm"></region-picker>
      <mt-datetime-picker
              ref="datePicker"
              type="date"
              :startDate="new Date('2000/1/1')"
              yearFormat="{value}年"
              monthFormat="{value}月"
              dateFormat="{value}日"
              :value="selectData?(new Date(selectData)):(new Date())"
              @confirm="dateConfirm"
      >
      </mt-datetime-picker>
    </div>
    <div>
      <mt-popup v-model="popMap" position="right" class="common-popup-wrapper">
        <div class="common-header-wrap">
          <mt-header title="定位" class="common-header">
            <mt-button slot="left" icon="back" @click="popMap=false"></mt-button>
          </mt-header>
        </div>
        <div class="common-popup-content">
          <map-select ref="map_select" :longitude="storeJoinin.store_longitude" :latitude="storeJoinin.store_latitude" @setPosition="setPosition"></map-select>
        </div>
      </mt-popup>
      <mt-popup position="right" v-model="showCrop" class="crop-wrapper common-popup-wrapper">
        <div class="common-header-wrap">
          <mt-header title="裁剪图片" class="common-header">
            <mt-button slot="left" icon="back" @click="showCrop=false"></mt-button>
            <div class="common-btn btn" slot="right" @click="useCrop">使用</div>
          </mt-header>
        </div>
        <vue-cropper class="common-popup-content" style="height: auto;position: absolute" ref="cropper" :maxImgSize="cropperOption.maxImgSize" :autoCropWidth="cropperOption.autoCropWidth" :autoCropHeight="cropperOption.autoCropHeight" :autoCrop="cropperOption.autoCrop" :img="cropperOption.img" :canMove="cropperOption.canMove" :outputType="cropperOption.outputType"></vue-cropper>
      </mt-popup>
    </div>
  </div>
</template>
<script>
  import { VueCropper } from 'vue-cropper'
  import { Toast, Indicator } from 'mint-ui'
import { mapState, mapMutations, mapActions } from 'vuex'
import Step from '../../Step'
import RegionPicker from '../../RegionPicker'
import MapSelect from '../../../components/MapSelect'
import { getStoreJoinin, uploadInfoFile, saveStoreJoinin2 } from '../../../api/seller'
import { getPointByAddress } from '../../../util/bmap'
import flexLine from '../../flexLine'
export default {
  components: {
    Step,
    RegionPicker,
    MapSelect,
    VueCropper,
	flexLine
  },
  data () {
    return {
      cropperOption: {
        img: '',
        canMove: false,
        autoCrop: true,
        autoCropWidth: 100,
        autoCropHeight: 100,
        maxImgSize: 500,
        outputType: 'png'
      },
      showCrop: false,
      options: [{ title: '公司资质' }, { title: '财务资质' }, { title: '店铺信息' }, { title: '合同签订' }],
      showimage: '',
      isshow: false,
      popMap: false,
      selectData: '',
      regionName: '',
      dataName: ''
    }
  },
  mounted () {
  },
  computed: {
    ...mapState({
      storeJoinin1: state => state.member.storeJoinin1,
      storeJoinin0: state => state.member.storeJoinin0,
      storeJoininType: state => state.member.storeJoininType,
      config: state => state.config.config
    }),
    storeJoinin:function(){
      if(this.storeJoininType==1){
        return this.storeJoinin1
      }else{
        return this.storeJoinin0
      }
    },
    getBannerStyle: function () {
      const { width, height } = window.screen
      let itemWidth = width
      let itemHeight = height
      return {
        maxWidth: itemWidth + 'px',
        maxHeight: itemHeight + 'px'
      }
    }
  },
  created: function () {
    getStoreJoinin().then(res => {
      var store_joinin = res.result.store_joinin
      if (store_joinin) {
          this.sellerJoininTypeSave({storeJoininType:store_joinin.store_type})
        if (store_joinin.joinin_state == 11 || store_joinin.joinin_state == 20 || store_joinin.joinin_state == 31) {
          this.$router.push({ name: 'SellerJoinin5' })
          return
        }
        if (store_joinin.joinin_state == 40) {
          Toast('您的店铺已开通')
          this.$router.push({ name: 'HomeSellerLogin' })
          return
        }
          this.sellerJoininSave({ storeJoinin: store_joinin })
          this.fetchConfig({}).then(
            response => {
              if(this.config.store_joinin_open==2 || this.config.store_joinin_open==3){
                if(this.config.store_joinin_open==3){
                  this.storeJoinin['store_type']=1
                }
                if(this.config.store_joinin_open==2){
                  this.storeJoinin['store_type']=0
                }
                this.$forceUpdate()
              }
            },
            error => {
              Toast(error.message)
            }
          )
      }
    }).catch(error => {
      Toast(error.message)
    })
  },

  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig',
    }),
    ...mapMutations({
      memberPoint: 'memberPoint',
      sellerJoininSave: 'sellerJoininSave',
        sellerJoininTypeSave: 'sellerJoininTypeSave'
    }),
    nextStep () {
      saveStoreJoinin2(this.storeJoinin).then(res => {
        this.sellerJoininSave({ storeJoinin: this.storeJoinin })
        this.$router.push({ name: 'SellerJoinin3' })
      }).catch(error => {
        Toast(error.message)
      })
    },
    setPosition (lat, lng, name) {
      this.popMap = false
      this.storeJoinin.company_address_detail = name
      this.storeJoinin.store_longitude = lng
      this.storeJoinin.store_latitude = lat
      this.$forceUpdate()
    },
    dateConfirm (value) {
      this.storeJoinin[this.dataName] = value.getFullYear() + '/' + (value.getMonth() + 1) + '/' + value.getDate()
      this.$forceUpdate()
    },
    onDate (name) {
      if (this.storeJoinin[name]) {
        this.selectData = this.storeJoinin[name]
      }
      this.dataName = name
      this.$refs.datePicker.open()
    },
    onPickerConfirm (values) {
      if (this.regionName == 'company_address') {
        this.storeJoinin.company_address = this.getRegionStr(values)
        this.storeJoinin.company_province_id = values[values.length - 1].area_id
      }
      if (this.regionName == 'business_licence_address') {
        this.storeJoinin.business_licence_address = this.getRegionStr(values)
      }
      this.selectCity(values.length > 1 ? values[1].area_name : values[0].area_name)
      this.$forceUpdate()
    },
    onRegion (name) {
      this.regionName = name
      this.$refs.picker.currentValue = true
    },
    getRegionStr (values) {
      let title = ''
      for (let i = 0; i < values.length; i++) {
        const element = values[i]
        if (i !== 0) {
          title = title + ' ' + element.area_name
        } else {
          title = title + element.area_name
        }
      }
      return title
    },
    openImage (src) {
      this.showimage = src
      this.isshow = true
    },
    dropImage () {
      this.storeJoinin.business_licence_number_electronic = ''
      this.$forceUpdate()
    },
    useCrop () {
      this.$refs.cropper.getCropBlob(res => {
        let files = new window.File([res], 'temp.png', { type: res.type })
        let formdata = new FormData()

        formdata.append('file', files)
        formdata.append('name', 'file')

        uploadInfoFile(formdata).then(res => {
          this.storeJoinin.business_licence_number_electronic = res.result.path
          this.storeJoinin.business_licence_number_electronic_url = res.result.url
          this.showCrop = false
          Indicator.close()
          this.$forceUpdate()
        }).catch(function (error) {
          Toast(error.message)
          Indicator.close()
        })
      })
    },
    uploadImage (type, event) {
      let that = this
      let file = event.target.files[0]
      let reader = new FileReader()
      let rs = reader.readAsDataURL(file)
      reader.onload = (e) => {
        that.cropperOption.img = e.target.result
        let image = new Image()
        image.src = e.target.result
        image.onload = function () {
          that.cropperOption.autoCropWidth = window.screen.width
          that.cropperOption.autoCropHeight = this.height / this.width * window.screen.width
          that.cropperOption.maxImgSize = window.screen.height - 40
          that.showCrop = true
          that.$forceUpdate()
        }
      }
    },
    selectCity (city_name) {
      getPointByAddress(city_name).then(res => {
        if (res.result.location) {
          var lng = res.result.location.lng
          var lat = res.result.location.lat
          if (this.regionName == 'company_address') {
            this.storeJoinin.store_latitude = lat
            this.storeJoinin.store_longitude = lng
          }
          if (this.regionName == 'business_licence_address') {

          }

          this.memberPoint({ point: { lng: lng, lat: lat, address: res.result.formatted_address, cityCode: res.result.cityCode, cityName: city_name } })
          // this.$forceUpdate()
        } else {
          Toast('无法获取城市位置')
        }
      }).catch(function (error) {
        Toast(error.message)
      })
    }

  }
}
</script>
<style  lang="scss" scoped>
.common-header{
	.btn{background: #000;color: #fff;box-shadow: 0px 2px 4px #d2d2d2;}
}
	.main-content{background: #fff;padding:0 $pageSpace}
  .container {
    background: #fff;
  }
  .label {
    padding: .5rem;
    font-size: .8rem;
    background: #eee;
  }
  .user-avatar-wrapper{display: inline-block;vertical-align: top;margin-right: .5rem;margin-bottom:.5rem}
  .user-avatar-wrapper .del-btn{position:absolute;bottom:.2rem;right:.2rem}
  .user-avatar {
    display: block;
    border:1px solid #eee;
    position: relative;
    width: 5rem;
    height: 5rem;
    margin: 0 auto;
    text-align: center;
    img {
      width: 100%;
      height: 100%
    }
    input {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0
    }
    .center-text{padding:.2rem;padding-top:3.5rem;font-size:.6rem}
  }
  .user-avatar::before {
    position: absolute;
    font-size: 1.5rem;
    line-height: 5rem;
    left: 50%;
    margin-left: -.75rem;
    color: rgba(0, 0, 0, 0.5)
  }
</style>
